import { IResourceComponentsProps, GetListResponse, useForm } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import Cw8List from "components/cw8/Cw8List";
import { ChildForm } from "interfaces/schemaDB";

export const SubsectionPubsList: React.FC<IResourceComponentsProps<GetListResponse<{}>>> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'subsectionPub';
    const { id } = useForm();
    const childrenForms : ChildForm[] =[
        
    {
        resourceName :"fragmentPub",
        title : "Fragment",
        field : "frs_id_subsection"
    },
    ]

    return(
        <Cw8EditWrapper
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></Cw8EditWrapper>
    )
       
};
